import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import Header from "./Header";
import HeroList from "./HeroList";
import TextInsertion from "./TextInsertion";
import { makeStyles, ProgressBar } from "@fluentui/react-components";
import { Ribbon24Regular, LockOpen24Regular, DesignIdeas24Regular } from "@fluentui/react-icons";
import { insertText } from "../taskpane";
import { debug } from 'webpack';

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    justifyContent: "center",
  },
  dynamifyWebApp: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  borderedBox: {
    border: "4px solid #4a5568", /* Dark gray border */
    borderRadus: "12px",
    padding: "20px",
    backgroundColor:" #ffffff",
    boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  message: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#2d3748",
    marginBottom: "10px",
    textAlign: "left",
  },
  instructions: {
    fontSize: "12px",
    color: "#2d3748",
    lineHeight: "1.5",
    textAlign: "left",
    width:"90%"
  },
  container: {
    marginTop: "40px",
    marginBottom: "40px",
    textAlign: "center",
  },
  loader: {
    marginTop: "30vh",
    textAlign: "center",
  }
});

const App = (props) => {
  const { title } = props;
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const styles = useStyles();
  useEffect(() => {
    const item = Office.context.mailbox.item;
    if (item && item.itemType === Office.MailboxEnums.ItemType.Appointment && !item.itemId) {
      setShowDialog(true);
    } else {
      setShowDialog(false);
      Office.onReady(() => {
        Office.auth.getAccessToken({ allowSignInPrompt: true, allowConsentPrompt: true })
          .then(token => {
            fetch('https://tabedc4e8.azure-api.net/check-consent/consumeMicrosoftOIDC', {
              headers: { 
                'Authorization': `Bearer ${token}`,
                'baseURL': 'https://embed.everyday.dynamify.com'
              }
            })
              .then(response => response.json())
              .then(data => {
                if (data.success && data.uri) {
                  data.uri = data.uri + "/storeId/22214"
                  setUrl(data.uri); // Assuming 'uri' is the field name; adjust if it's 'url'
                  setLoading(false);
                } else {
                  console.error('Error getting URL:', data);
                  setError('Failed to retrieve URL from API');
                  setLoading(false);
                }
              })
              .catch(error => {
                console.error('Error fetching URL:', error);
                setError('API call failed: ' + error.message);
                setLoading(false);
              });
          })
          .catch(error => {
            console.error('Error getting access token:', error);
            if (error.code === 13000) {
              setError('SSO not supported in this environment');
              // Optional: Trigger fallback OAuth flow here
              // Office.context.ui.displayDialogAsync(...);
            } else {
              setError('SSO failed: ' + error.message);
            }
            setLoading(false);
          });
      });
    }
  }, []); // Empty dependency array to run once on mount

  // The list items are static and won't change at runtime,
  // so this should be an ordinary const, not a part of state.
  const listItems = [
    {
      icon: <Ribbon24Regular />,
      primaryText: "Achieve more with Office integration",
    },
    {
      icon: <LockOpen24Regular />,
      primaryText: "Unlock features and functionality",
    },
    {
      icon: <DesignIdeas24Regular />,
      primaryText: "Create and visualize like a pro",
    },
  ];
  if (loading && !showDialog) { 
    return ( 
      <div className={styles.root}>
        <div className={styles.loader}>
        <h3>Getting Your Profile Ready...</h3>
            <ProgressBar striped variant="success" now={25} key={1} />
        </div>
      </div> 
    )
  };
  if (showDialog) {
    return (
      <div className={styles.root}>
        <div className={styles.container}>
          <img width="90" height="90" src="../../assets/logo-filled.png" alt="Dynamify" title="Dynamify" />
          <h2>Welcome</h2>
        </div>
        <div className={styles.borderedBox}>
          <p className={styles.message}>Instructions: </p>
          <ul className={styles.instructions}>
            <li>Save the calendar invite to get started.</li>
            <li>Select your event and launch the Add-in.</li>
            <li>The Add-in detects your event details.</li>
            <li>Place an order directly for your chosen reservation.</li>
        </ul>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className={styles.root}>
        <h1>Error: {error}</h1>
      </div>
    );
  }
  return (
    <div className={styles.root}>
      {/* <Header logo="assets/logo-filled.png" title={title} message="Welcome" />
      <HeroList message="Discover what this add-in can do for you today!" items={listItems} />
      <TextInsertion insertText={insertText} /> */}
      <iframe aria-label="Dynamify%20Limited%20%2F%20General" name="platform-website-tab" allowfullscreen="allowFullScreen" className={styles.dynamifyWebApp} src={url}></iframe>
    </div>
  );
};

App.propTypes = {
  title: PropTypes.string,
};

export default App;
